import { forwardRef } from "react";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { useId } from "../../hooks/useId";
import { LoadingGroup } from "capitalrx-components-2.0/lib/general";
import { RadioProps } from "./Radio";
import { InputContainer } from "../shared";
import { Placeholder } from "./Placeholder";
import { SharedRadio } from "./SharedRadio";
import styles from "./styles.module.scss";

/**
 * The `Input` component properties.
 */

export interface InputProps extends RadioProps {}

/**
 * The main Radio component. This component is not exported to the outside world. This component is used inside the components that are being exported.
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(props, ref) {
  const { defaultValue = null, instructions, hideInstructions, hideLabel } = props;
  const { value = defaultValue } = props;

  const id = useId();

  const selected = value === true;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [
      styles.Radio,
      "radio",
      {
        selected,
      },
    ],
    testIdPrefix: "radio",
  });

  return (
    <LoadingGroup.Placeholder fallback={<Placeholder className={props.className} style={props.style} />}>
      <InputContainer
        {...getBasePropsFromHtmlProps(baseHtmlProps)}
        id={id}
        instructions={instructions}
        tooltip={undefined}
        required={undefined}
        hideLabel={hideLabel}
        hideInstructions={hideInstructions}
      >
        <SharedRadio {...props} id={id} ref={ref} />
      </InputContainer>
    </LoadingGroup.Placeholder>
  );
});
